import { graphql, useLazyLoadQuery, useRelayEnvironment } from 'react-relay';
import { useFetchQuery } from '@sparknz/journeys-common';

import { useHeaderProfileQuery } from '__generated__/useHeaderProfileQuery.graphql';

const useHeaderProfileQueryQuery = graphql`
  query useHeaderProfileQuery {
    authenticatedInfo {
      isGuest
      isLoggedIn
      profile {
        sparkID
        lastName
        firstName
        loginOption
      }
    }
  }
`;

export default function useHeaderProfile() {
  const {
    authenticatedInfo: { isLoggedIn, isGuest, profile },
  } = useLazyLoadQuery<useHeaderProfileQuery>(
    useHeaderProfileQueryQuery,
    {},
    { fetchPolicy: 'network-only' },
  );

  const relayEnvironment = useRelayEnvironment();
  const { fetch: fetchProfile } = useFetchQuery<useHeaderProfileQuery>(
    useHeaderProfileQueryQuery,
    relayEnvironment,
  );

  function refetchUserProfile() {
    return fetchProfile({});
  }

  return {
    isLoggedIn,
    isGuest,
    hasSparkId: profile?.loginOption !== 'SparkGuest',
    profile,
    refetchUserProfile,
  };
}
